import { DocumentPage } from '@/components/DocumentPage'

/**
 * Страница /terms — Terms of Service (EU). Разметка-скелет: финальный
 * юридический текст предоставляет заказчик.
 */
const SECTIONS: { heading: string; body: string }[] = [
  { heading: '1. Introduction', body: 'These Terms govern your use of our website and access to our online courses. By using the service you agree to these Terms. [Final text to be provided.]' },
  { heading: '2. Eligibility', body: 'You must be at least 18 years old (or the age of majority in your country) to purchase a course.' },
  { heading: '3. Account', body: 'You are responsible for keeping your account and sign-in email secure and for all activity under your account.' },
  { heading: '4. Purchases and payment', body: 'Prices are shown in EUR. Payment is processed by our payment provider. Access is granted after successful payment.' },
  { heading: '5. Access to courses', body: 'Purchased courses are provided as online video lessons. Access duration is stated on the course page.' },
  { heading: '6. Intellectual property', body: 'All course materials are our intellectual property. You may not copy, share, resell or redistribute them.' },
  { heading: '7. Acceptable use', body: 'You agree not to misuse the service, share access, or attempt to disrupt its operation.' },
  { heading: '8. Refunds', body: 'Refunds are handled in line with our Refund Policy and applicable EU consumer law.' },
  { heading: '9. Disclaimer and liability', body: 'The service is provided “as is”. To the extent permitted by law, our liability is limited. [To be provided.]' },
  { heading: '10. Governing law', body: 'These Terms are governed by the laws of [jurisdiction]. [To be provided.]' },
  { heading: '11. Contact', body: 'For questions about these Terms contact us at [email].' },
]

export const TermsPage = () => (
  <DocumentPage title="Terms of Service">
    <p><em>This is a working draft. The final legal text will be provided.</em></p>
    {SECTIONS.map(section => (
      <section key={section.heading}>
        <h2>{section.heading}</h2>
        <p>{section.body}</p>
      </section>
    ))}
  </DocumentPage>
)

export default TermsPage
